<template>
  <div class="apply-form">
    <div v-if="!loading && actionId == null" class="text-center">
      <h1>{{ $t('application.requestInformationInvalid') }}</h1>
    </div>

    <div v-else-if="!loading" class="text-center">
      <h1>{{ $t('application.requestInformationHeadline') }}</h1>
      <div v-if="!dataUpdated" class="mt-8 mb-8 text-center">
        {{ $t('application.requestInformationInfo') }}
      </div>
      <div
        v-else
        class="mt-8 mb-8 text-center"
        v-html="$t('application.submitConfirmationMessage')"
      ></div>
    </div>

    <div v-if="!dataUpdated && actionId != null">
      <div
        class="apply-form__documents apply-form__section content-box content-box__color-secondary content-box__dense"
      >
        <h3>{{ $t('application.documents') }}</h3>

        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <default-types
              v-if="requestedInformation.DefaultTypes"
              :defaultTypes="requestedInformation.DefaultTypes"
              v-model="defaultTypeModels"
              :formId="formId"
              :allowedFileTypes="allowedFileTypes"
            ></default-types>
            <custom-types
              v-if="requestedInformation.CustomTypes"
              :customTypes="requestedInformation.CustomTypes"
              v-model="customTypesModels"
              :formId="formId"
              :allowedFileTypes="allowedFileTypes"
            ></custom-types>
            <extra-types
              v-if="requestedInformation.ExtraTypes"
              :extraTypes="requestedInformation.ExtraTypes"
              v-model="extraTypesModels"
              :formId="formId"
              :allowedFileTypes="allowedFileTypes"
            ></extra-types>
          </form>
        </ValidationObserver>

        <div class="d-flex justify-end">
          <v-btn
            @click="submitApplication"
            :loading="submitting"
            color="primary"
            class="ml-md-4 mt-4 mt-md-0 d-md-inline"
          >
            {{ $t('application.sendApplication') }}
            <v-icon class="ml-4">mdi-send</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { eventBus } from '@/event-bus';
import defaultTypes from '../components/application/request-information/default-types.vue';
import customTypes from '@/components/application/request-information/custom-types.vue';
import extraTypes from '@/components/application/request-information/extra-types.vue';
import { ValidationObserver } from 'vee-validate';
import { v4 as uuid } from 'uuid';

export default {
  components: {
    defaultTypes,
    customTypes,
    extraTypes,
    ValidationObserver
  },

  data: () => ({
    actionId: null,
    applicationId: null,
    requestedInformation: {},
    submitting: false,
    showErrorAlert: false,
    dataUpdated: false,
    errorAlertMessage: '',
    defaultTypeModels: {},
    extraTypesModels: {},
    customTypesModels: {},
    loading: true,
    allowedFileTypes: 'image/*, .pdf, .docx, .doc'
  }),

  async mounted() {
    if (!this.formId || this.formId === '') {
      this.setFormId(uuid());
    }

    const pActionId = parseInt(this.$route.params.actionId);
    const pApplicationId = parseInt(this.$route.params.applicationId);
    const pToken = this.$route.params.token;

    const data = await this.loadRequestedInformation({
      actionId: pActionId,
      applicationId: pApplicationId,
      token: pToken
    });

    if (!data) {
      this.loading = false;
      return;
    }

    this.actionId = data.actionID;
    this.applicationId = data.applicationID;
    this.requestedInformation = JSON.parse(data.requestedInformation);

    for (let key in this.requestedInformation) {
      for (let entry in this.requestedInformation[key]) {
        if (key.toLowerCase() == 'defaulttypes') {
          this.$set(this.defaultTypeModels, entry, null);
        } else if (key.toLowerCase == 'customtypes') {
          this.$set(this.customTypesModels, entry, null);
        } else if (key.toLowerCase == 'extratypes') {
          this.$set(this.extraTypesModels, entry, null);
        }
      }
    }

    this.loading = false;
  },

  computed: {
    ...mapState('applicationModule', {
      formId: 'formId'
    })
  },

  methods: {
    ...mapMutations('applicationModule', {
      setFormId: 'setFormId'
    }),

    ...mapActions('applicationModule', {
      loadRequestedInformation: 'loadRequestedInformation',
      updateData: 'updateApplicationData'
    }),

    async submitApplication() {
      this.showErrorAlert = false;
      this.errorAlertMessage = '';

      const result = await this.$refs.observer.validate();

      if (!result) {
        eventBus.$emit('errorMessage', this.$t('application.formInvalid'));

        return;
      }

      this.submitting = true;

      try {
        const newData = {
          requestedInformation: {
            DefaultTypes: this.defaultTypeModels,
            CustomTypes: this.customTypesModels,
            ExtraTypes: this.extraTypesModels
          },
          applicationId: this.applicationId,
          actionId: this.actionId
        };

        const response = await this.updateData(newData);

        const result = await response.json();

        if (response.ok && result.success) {
          this.dataUpdated = true;
        } else {
          eventBus.$emit(
            'errorMessage',
            this.$t(`application.errors.${result.errorCode}`)
          );

          this.showErrorAlert = true;
          this.errorAlertMessage = this.$t(
            `application.errors.${result.errorCode}`
          );
        }

        window.scrollTo(0, 0);
      } catch (error) {
        eventBus.$emit(
          'errorMessage',
          'Es ist ein Fehler beim Speichern der Bewerbung aufgetreten'
        );
      }

      this.submitting = false;
    }
  }
};
</script>
